<div *ngIf="this.forgotPasawordStatus==1">
    <div class="basicrow f-lsemi roboto-r text-center">
        <div class="basicrow" [hidden]="this.actualRegisterViewStep === 'step11'">
            <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
            ¿Olvidaste tu contraseña?
        </div>
    </div>
    <div>
        <form [formGroup]="forgotForm">
            <div class="basicrow m-top-i">
                <label class="label-f">Correo Electrónico o Número de Teléfono</label>
                <div class="basicrow requiredTrue">
                    <div class="p-rigth">
                        <img data-toggle="popover" data-html="true" data-content="Número de Teléfono celular o fijo." data-placement="bottom" class="icon-i" src="../../assets/images/tooltip1.png">
                    </div>
                    <input class="inp-f" type="text" [(ngModel)]="this.subscriberEmail" required formControlName="subscriberEmail" id="subscriberEmail">
                </div>
            </div>
            <div style="padding-top: 10px; width: 100%; float: left;">
                Por favor, demuestre que es un humano. 
            </div>
            <div class="basicrow" style="padding-top: 20px;">
                <ngx-recaptcha2 #captchaElem [siteKey]="this.siteKey" formControlName="recaptcha"></ngx-recaptcha2>
            </div>
        </form>
        <div class="basicrow m-top-i">
            <a (click)="this.validarUser2();" class="btns red vcenter"
                [ngClass]="{'red': !forgotForm.invalid, 'gray': forgotForm.invalid}">
                <span class="tabcell">
                    Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>
</div>